var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisibilityOffIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3984 19.75L5.39844 4.75M10.1984 10.6916C9.82502 11.1033 9.59844 11.644 9.59844 12.2363C9.59844 13.5261 10.673 14.5717 11.9984 14.5717C12.6096 14.5717 13.1674 14.3494 13.5911 13.9834M20.4372 14.5717C21.2635 13.3348 21.5984 12.3261 21.5984 12.3261C21.5984 12.3261 19.4138 5.35 11.9984 5.35C11.5821 5.35 11.1823 5.37199 10.7984 5.41349M17.3984 17.5994C16.021 18.4781 14.2478 19.0995 11.9984 19.0627C4.67536 18.943 2.39844 12.3261 2.39844 12.3261C2.39844 12.3261 3.45629 8.94808 6.59844 6.89332",
    stroke: "#787878",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityOffIcon);
export default __webpack_public_path__ + "static/media/VisibilityOffIcon.ceea7d3e7f653f1e327513c146c1aea5.svg";
export { ForwardRef as ReactComponent };